import(/* webpackMode: "eager", webpackExports: ["ClientOnly"] */ "/home/runner/work/monorepo/monorepo/apps/beemo/app/[...slug]/client.tsx");
